import { create } from "axios";
import { LOGIN } from "../constants";
import { setItemOnLS, removeItemFromLS, getItemFromLS } from "./util";

const initDefault = (config) => {
  const defaultConf = {
    baseURL: config.apiUrl
  };

  return create(defaultConf);
};

class Axios {
  static core;

  static config;

  static loadingState;

  static history;

  static logout;

  static init(config, loadingState, history, logout, storeNextUrl) {
    if (!config.core) {
      throw Error("Axios configuration is incorrect");
    }

    Axios.history = history;
    Axios.config = config;
    Axios.logout = logout;

    if (!Axios.core) {
      Axios.core = initDefault(config.core);
      Axios.core.interceptors.request.use((request) => {
        request.headers.Authorization = `Bearer ${
          getItemFromLS("tokenId") || ""
        }`;

        return request;
      });
      Axios.core.interceptors.response.use(
        (response) => response,
        (error) => {
          if (error.response.status === 401) {
            storeNextUrl(
              `${window.location.pathname}${window.location.search}`
            );
            history.push(`/${getItemFromLS("c_sh_n")}/${LOGIN}`);
            logout();
          }

          return Promise.reject(error);
        }
      );
    }

    Axios.loadingState = loadingState;
  }

  static setAuthToken(token) {
    if (token) {
      Axios.core.defaults.headers.common.Authorization = `Bearer ${token}`;
      setItemOnLS("tokenId", token);
    } else {
      delete Axios.core.defaults.headers.common.Authorization;
      removeItemFromLS("tokenId");
    }
  }
}

export default Axios;
